var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportUserBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C21.2 30 17.9 26.9 16.6 22.5C15.5 22.5 14.6 21.2 14.5 19.6C14.4 18.1 15.1 16.8 16 16.5C16.3 10.5 17.9 6.90002 24 6.90002C30.1 6.90002 31.7 10.5 32 16.5C33 16.7 33.6 18.1 33.5 19.6C33.4 21.2 32.5 22.4 31.4 22.5C30.1 26.9 26.8 30 24 30Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26.5C36.4 28 41 31.3 41 38C36.5 40.1 29.9 41 24 41C18.1 41 11.5 40.1 7 38C7 31.3 11.6 28 18 26.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportUserBlack);
export default __webpack_public_path__ + "static/media/icons-2_export-USER-BLACK.1d68458f14d5c5f6e3ca5da0fe9471e2.svg";
export { ForwardRef as ReactComponent };